import axios from "axios";

export default {
	methods: {
		async $api(url, data) {
			return (await axios({
				method: 'post',
				url,
				data
			}).catch(e => {
			})).data;
		},
		async $mapi(url, data) {
			return (await axios.post(url, data, { headers: {'Content-Type': 'multipart/form-data'}
				}).catch(e => {
			})).data;
		}
	}
}